class ContactModuleHelper {
    static getTypeLabelByValue = (value: string) => {
        switch (value) {
            case 'email':
                return 'E-mailadres';
            case 'phone':
                return 'Telefoonnummer';
            case 'linkedin':
                return 'LinkedIn';
            default:
                return 'UNKNOWN';
        }
    }
}

export default ContactModuleHelper;